<!--
 * @Author: wencd wencd@yxt.com
 * @Date: 2022-09-23 15:53:24
 * @LastEditors: wencd wencd@yxt.com
 * @LastEditTime: 2022-09-30 16:50:17
 * @FilePath: \yxt-biz-pc\packages\circle-audit\src\main.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="yxtbiz-circle-audit">
    <div class="standard-size-16 color-gray-10">
      <div class="font-bolder">{{$t('pc_biz_bbs_lbl_joinerInfo'/**加入人信息 */)}}</div>
      <yxtf-row type="flex" class="mv24 font-normal font-size-14">
        <yxtf-col :span="12" class="mh2 flex">
          <span class="color-gray-7 nowrap">{{ $t('pc_biz_bbs_lbl_name' /** 姓名 */) }}：</span>
          <yxtf-tooltip
            :open-filter="true"
            placement="top">
            <div slot="content">
              <yxtbiz-user-name
                :name="detail.fullName"
              />
              <span>{{'（'+detail.username+'）'}}</span>
            </div>
            <div class="yxtbiz-circle-audit_ellipsis">
              <yxtbiz-user-name
                :name="detail.fullName || ''"
              />
              <span v-show="detail.username">{{'（'+detail.username+'）'}}</span>
            </div>
          </yxtf-tooltip>
        </yxtf-col>
        <yxtf-col :span="12" class="mh2 flex">
          <span class="color-gray-7 nowrap">{{ $t('pc_biz_bbs_lbl_dept' /**  部门 */) }}：</span>
          <yxtf-tooltip placement="top" :open-filter="true">
            <yxtbiz-dept-name
              slot="content"
              :name="detail.deptName"
            />
            <yxtbiz-dept-name
              class="yxtbiz-circle-audit_ellipsis"
              :name="detail.deptName || '--'"
            />
          </yxtf-tooltip>
        </yxtf-col>
      </yxtf-row>
      <yxtf-row type="flex" class="mv24 font-normal font-size-14">
        <yxtf-col :span="12" class="mh2 flex">
          <span class="color-gray-7 nowrap">{{ $t('pc_biz_bbs_lbl_possion' /**岗位 */) }}：</span>
          <yxtf-tooltip :open-filter="true" placement="top">
            <yxtbiz-position-name
            slot="content"
            :name="detail.positionName"
            />
            <yxtbiz-position-name class="yxtbiz-circle-audit_ellipsis" :name="detail.positionName || '--'" />
          </yxtf-tooltip>
        </yxtf-col>
        <yxtf-col :span="12" class="mh2 flex">
          <span class="color-gray-7 nowrap">{{$t('pc_biz_bbs_lbl_circle'/**圈子 */)}}：</span>
          <yxtf-tooltip
            :open-filter="true"
            :content="detail.scName"
            placement="top">
            <div class="yxtbiz-circle-audit_ellipsis">{{ detail.scName || '--' }}</div>
          </yxtf-tooltip>
        </yxtf-col>
      </yxtf-row>
    </div>
  </div>
</template>

<script>
import { getDeatilApi } from './service';
export default {
  name: 'YxtbizCircleAudit',
  name_zh: '社区圈子接审核中心',
  props: {
    id: {
      type: String,
      default: '',
      desc: '详情id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      detail: {}
    };
  },
  created() {
    this.getCircleDeatil();
  },
  methods: {
    getCircleDeatil() {
      getDeatilApi(this.id).then(res => {
        this.detail = res || {};
      });
    }
  }
};
</script>
